import { isEqual } from "lodash";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  Changepwd: "[Changepwd] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  OrgUpdate: "[Update Org] Auth API",
  FetchUser: "",
  darkLightMode: "[darkLightMode] Auth API",
  Authenticated: "[Authenticated] Action",
  Ennumber: "[Ennumber] Action",
  AssetDetailValue: "[AssetDetail] Action",
};

const initialAuthState = {
  user: undefined,
  authToken: undefined,
  darkLightMode: true,
  pin: "",
  ennumber: "",
  assetDetail: "",
};

export const reducer = persistReducer(
  {
    storage,
    key: "v709-auth",
    whitelist: ["user", "authToken", "auth", "pin", "ennumber", "assetDetail"],
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
    case actionTypes.Login: {
      const { authToken } = action.payload;

      const { pin } = state;

      return { pin, authToken, user: undefined };
    }

    case actionTypes.Register: {
      const { authToken } = action.payload;

      const { pin } = state;

      return { pin, authToken, user: undefined };
    }

    case actionTypes.Changepwd: {
      const { authToken } = action.payload;

      const { pin } = state;

      return { pin, authToken, user: undefined };
    }

    case actionTypes.Logout: {
      const { pin } = state;

      return {
        ...initialAuthState,
        pin,
      };
    }

    case actionTypes.UserLoaded: {
      const { user } = action.payload;

      if (!isEqual(user, state.user)) {
        return { ...state, user };
      }

      return state;
    }

    case actionTypes.OrgUpdate: {
      const { updateUserOrgData } = action.payload;

      const updatedState = {
        ...state,
        user: updateUserOrgData.updateOrganizationName,
      };

      return updatedState;
    }

    case actionTypes.FetchUser: {
      return state.user;
    }

    case actionTypes.Authenticated: {
      const { pin } = action.payload;

      return { ...state, pin };
    }

    case actionTypes.darkLightMode: {
      return { ...state, darkLightMode: !state.darkLightMode };
    }

    case actionTypes.Ennumber: {
      const { ennumber } = action.payload;

      return { ...state, ennumber };
    }

    case actionTypes.AssetDetailValue: {
      const { assetDetail } = action.payload;

      return { ...state, assetDetail };
    }

    default:
      return state;
    }
  },
);

export const actions = {
  login: authToken => ({
    type: actionTypes.Login,
    payload: { authToken },
  }),
  changepwd: authToken => ({
    type: actionTypes.Changepwd,
    payload: { authToken },
  }),
  register: authToken => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: user => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: user => ({
    type: actionTypes.UserLoaded,
    payload: { user },
  }),
  updateOrgUser: updateUserOrgData => ({
    type: actionTypes.OrgUpdate,
    payload: { updateUserOrgData },
  }),
  fetchUser: () => ({ type: actionTypes.FetchUser }),
  authenticated: pin => ({
    type: actionTypes.Authenticated,
    payload: { pin },
  }),
  darkLightMode: mode => ({
    type: actionTypes.darkLightMode,
    payload: { mode },
  }),
  ennumber: ennumber => ({
    type: actionTypes.Ennumber,
    payload: { ennumber },
  }),
  assetDetailValue: assetDetail => ({
    type: actionTypes.AssetDetailValue,
    payload: { assetDetail },
  }),
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Changepwd, function* registerSaga() {
    yield put(actions.requestUser());
  });
}
